<template>
  <div>
    <pa-admin-toolbar
      :per-page="perPage"
      :search.sync="searchInput"
      :from.sync="fromInput"
      :to.sync="toInput"
      :busy="loading"
      @per-page="setPerPage"
      @search="applySearch"
    >
      <button type="button" class="paa-btn paa-btn--secondary" :disabled="loading || !total" @click="exportRows">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16" /></svg>
        Export All
      </button>
    </pa-admin-toolbar>

    <div class="paa-filters">
      <pa-admin-filter label="SEO Manager" :value="filters.campaignManager" :options="managerOptions" @input="setFilter('campaignManager', $event)" />
    </div>

    <div v-if="loadError" class="paa-error">{{ loadError }}</div>

    <div class="paa-stat-row">
      <span class="paa-muted">{{ stats.invoicesCount || 0 }} setup invoices, {{ stats.unpaidCount || 0 }} unpaid</span>
      <span class="paa-spacer"></span>
      <b>Total paid: {{ money(totalPaid) || '$0.00' }}</b>
    </div>

    <div class="paa-card paa-tblwrap">
      <table class="paa-tbl">
        <thead>
          <tr>
            <th :class="thClass('userId')" @click="sortBy('userId')">{{ sortMark('userId') }}User ID</th>
            <th :class="thClass('userEmail')" @click="sortBy('userEmail')">{{ sortMark('userEmail') }}Email</th>
            <th :class="thClass('id', 'paa-r')" @click="sortBy('id')">{{ sortMark('id') }}Invoice ID</th>
            <th :class="thClass('sentAt')" @click="sortBy('sentAt')">{{ sortMark('sentAt') }}Invoice sent</th>
            <th :class="thClass('paidAt')" @click="sortBy('paidAt')">{{ sortMark('paidAt') }}Paid on</th>
            <th>SEO Manager</th>
            <th :class="thClass('amount', 'paa-r')" @click="sortBy('amount')">{{ sortMark('amount') }}Amount ($)</th>
            <th>Coupon</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.key">
            <td>{{ row.userId }}</td>
            <td>
              <a :href="userAccountsHref(row.userEmail)" target="_blank" rel="noopener">{{ row.userEmail }}</a>
              <span class="paa-sub">{{ row.siteName }}</span>
            </td>
            <td class="paa-r" :title="row.invoiceNumber ? `Stripe invoice ${row.invoiceNumber}` : null">{{ row.id }}</td>
            <td>{{ row.sentAt || '' }}</td>
            <td>{{ row.paidAt || '' }}</td>
            <td>{{ row.manager ? row.manager.name : '' }}</td>
            <td class="paa-r">{{ money(row.amount) }}</td>
            <td>{{ couponLabel(row) }}</td>
            <td><pa-admin-badge :badge="row.status" /></td>
          </tr>
          <tr v-if="!records.length">
            <td class="paa-empty" colspan="9">{{ loading ? 'Loading…' : 'No setup invoice matches this search.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pa-admin-pager :page="page" :page-count="pageCount" @change="setPage" />
  </div>
</template>

<script>
import PaAdminBadge from './PaAdminBadge.vue'
import PaAdminFilter from './PaAdminFilter.vue'
import PaAdminPager from './PaAdminPager.vue'
import PaAdminToolbar from './PaAdminToolbar.vue'
import paAdminListMixin from './paAdminListMixin'

/** Setup Fees Timeline: every setup fee invoice, emailed or paid. Status: Sent, Paid, Overdue (unpaid 7+ days). */
export default {
  name: 'AdminPopAuthoritySetupFeesTimeline',
  components: { PaAdminBadge, PaAdminFilter, PaAdminPager, PaAdminToolbar },
  mixins: [paAdminListMixin],
  paAdmin: { action: 'getPopAuthoritySetupFeesForAdmin', sort: 'sentAt', tab: 'setup-fees' },
  methods: {
    couponLabel (row) {
      if (!row.coupon) return ''
      return row.couponAmountOff ? `Yes (${this.money(row.couponAmountOff)} off)` : 'Yes'
    },
    exportRows () {
      const header = [
        'User ID', 'Email', 'Project', 'Invoice ID', 'Stripe invoice', 'Invoice sent', 'Paid on', 'SEO Manager',
        'Amount ($)', 'Coupon', 'Coupon amount off ($)', 'Status',
      ]
      return this.exportCsv(header, (row) => [
        row.userId, row.userEmail, row.siteName, row.id, row.invoiceNumber || '', row.sentAt || '',
        row.paidAt || '', row.manager ? row.manager.name : '', row.amount, row.coupon || '',
        row.couponAmountOff || '', row.status ? row.status.label : '',
      ])
    },
  },
}
</script>
